export default __webpack_public_path__ + "static/mitech-client-logo-03-hover-5b29277de0f3e02b0a65a167c3236e77.png";